import { defineStore } from "pinia";
import { markRaw } from "vue";
import { api, type Result } from "../api";
import {
  OrderStatusResponseSchema,
  type OrderStatusResponse,
} from "../schemas/order/status";

class OrderStatusApi {
  private readonly url = "/orders-client/status/";

  getOrderStatus(id: string): Promise<Result<OrderStatusResponse>> {
    return api.get(this.url, OrderStatusResponseSchema, { id });
  }
}

const store = defineStore("order-status", () => ({
  api: markRaw(new OrderStatusApi()),
}));

export function useOrderStatus() {
  return store().api;
}
